<div
  id="lead-source-modal"
  role="dialog"
  aria-labelledby="leadSourceModalLabel"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="leadSourceModalLabel">
          {{ (isNew ? 'leadSource.modal.titleAdd' : 'leadSource.modal.titleAlter') | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup" class="w-100">
          <div class="col-12 mb-3">
            <label class="form-label"
              >{{ 'leadSource.modal.channelLabel' | translate }}</label
            >
            <mat-select
              formControlName="channel"
              class="form-control"
              [placeholder]="'leadSource.modal.channelPlaceholder' | translate"
              required
            >
              @for (item of listChannel; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
              }
            </mat-select>
            <field-error-component
              [field]="'channel'"
              [label]="'leadSource.modal.channelFieldLabel' | translate"
              [formGroup]="formGroup"
            ></field-error-component>
          </div>

          <div class="col-12 mb-3">
            <label class="form-label m-0"
              >{{ 'leadSource.modal.keywordsLabel' | translate }}</label
            ><br />
            <small class="form-text text-primary mb-1"
              >{{ 'leadSource.modal.keywordsHint' | translate }}</small
            >
            <input
              type="text"
              class="form-control"
              formControlName="keywords"
              [placeholder]="'leadSource.modal.keywordsPlaceholder' | translate"
              [formControlName]="'keywords'"
              (keydown)="onInputChange($event)"
            />

            <div class="keyword">
              @for (word of keywordsList; track $index) {
              <mat-chip-row (removed)="removeKeyword(word)" [editable]="false">
                {{ word }}
                <button matChipRemove [attr.aria-label]="('leadSource.modal.removeKeywordAria' | translate) + ' ' + word">
                  <i class="mdi mdi-close"></i>
                </button>
              </mat-chip-row>
              }
            </div>
            <field-error-component
              [field]="'keywords'"
              [label]="'leadSource.modal.keywordsFieldLabel' | translate"
              [formGroup]="formGroup"
            />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'leadSource.modal.originLabel' | translate }}</label>
            <input
              type="text"
              class="form-control"
              maxlength="100"
              formControlName="name"
              [placeholder]="'leadSource.modal.originPlaceholder' | translate"
              required
            />
            <field-error-component
              [field]="'name'"
              [label]="'leadSource.modal.originFieldLabel' | translate"
              [formGroup]="formGroup"
            />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'leadSource.modal.descriptionLabel' | translate }}</label>
            <textarea
              [rows]="3"
              [cols]="50"
              class="form-control"
              formControlName="description"
              [placeholder]="'leadSource.modal.descriptionPlaceholder' | translate"
            >
            </textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'leadSource.modal.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary"
          (click)="save()"
          [disabled]="loading || formGroup.invalid"
        >
          @if (loading) {
          <mat-spinner [diameter]="25" mode="indeterminate" class="px-3" />
          } @else {
          {{ (isNew ? 'leadSource.modal.save' : 'leadSource.modal.alter') | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
